module.exports = __webpack_public_path__ + "static/media/laurie.d174e873.jpg";